var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterRed = function SvgTwitterRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#c00000",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 23c6.793 0 10.508-5.387 10.508-10.058 0-.153 0-.305-.01-.457A7.344 7.344 0 0 0 26 10.655a7.63 7.63 0 0 1-2.121.557 3.58 3.58 0 0 0 1.623-1.956 7.605 7.605 0 0 1-2.345.858c-1.144-1.165-2.963-1.45-4.437-.695-1.473.754-2.234 2.361-1.856 3.92-2.97-.143-5.736-1.486-7.611-3.694-.98 1.615-.48 3.682 1.143 4.719a3.792 3.792 0 0 1-1.676-.443v.045c0 1.683 1.24 3.132 2.963 3.465a3.847 3.847 0 0 1-1.668.061c.484 1.44 1.87 2.427 3.45 2.455a7.624 7.624 0 0 1-4.586 1.516 7.85 7.85 0 0 1-.879-.05 10.799 10.799 0 0 0 5.66 1.584",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
};
export default SvgTwitterRed;